module.exports = __webpack_public_path__ + "static/img/ai-icon.9ace4de2.png";